function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mark_query, deleteItem, getExcelPath, download, item_import, saveItem, updateValidStatus } from '@/api/baseDataManage';
import { getCompanyList } from '@/api/baseDate';
export default {
  name: 'selfMark',
  data: function data() {
    return _defineProperty({
      markFormIsCompanyLevelShow: false,
      //编辑隐藏
      markFormNewIsCompanyLevelShow: false,
      //新增隐藏
      newumarBtn: false,
      //标的新增
      new_edit: false,
      //标的编辑
      fileList: [],
      company: '',
      //保险公司
      companyList: [],
      //获取保险公司列表并匹配
      // 查询条件
      form: {
        insuranceCompanyCode: '',
        itemName: '',
        //标的名称
        itemCode: '',
        //标的代码
        pageNo: 1,
        pageSize: 10,
        userName: '' //客户名称

      },
      isCompanyLevel: [{
        key: '1',
        value: '是'
      }, {
        key: '0',
        value: '否'
      }],
      flag: [{
        key: '1',
        value: '有效'
      }, {
        key: '0',
        value: '无效'
      }],
      total: 0,
      //数据条数
      // 列表数据
      tableData: [],
      loading: false,
      screenLoading: null,
      editData: {},
      markForm: {
        tbcItemId: '',
        type: '',
        itemCode: '',
        itemName: '',
        hsCode: '',
        hxItemCode: '',
        userCode: '',
        userName: '',
        isCompanyLevel: ''
      },
      markForm_new: {
        tbcItemId: '',
        type: '',
        itemCode: '',
        itemName: '',
        hsCode: '',
        hxItemCode: '',
        userCode: '',
        userName: '',
        isCompanyLevel: ''
      },
      rule: {
        isCompanyLevel: [{
          required: true,
          message: '请输入是否到保险公司层级',
          trigger: 'change'
        }],
        // itemCode: [
        //   { required: true, message: '请输入标的代码', trigger: 'change' },
        //   { pattern: /^[a-zA-Z\d]+$/, message: '标的代码格式不正确' }
        // ],
        itemName: [{
          required: true,
          message: '请输入标的名称',
          trigger: 'change'
        } // { pattern: '', message: '标的名称格式不正确' }
        // { pattern: /^[A-Z0-9a-z\u4e00-\u9fa5\（\）\(\)\,\、]+$/, message: '标的名称格式不正确' }
        ],
        // userName: [
        //   { required: true, message: '请输入客户名称', trigger: 'change' },
        //   // { pattern: /^[A-Za-z\u4e00-\u9fa5\（\）\(\)\.]+$/, message: '客户名称格式不正确' }
        // ],
        hsCode: [{
          required: false,
          message: '请输入映射HScode',
          trigger: 'change'
        }, {
          pattern: /^[A-Z0-9a-z]+$/,
          message: '映射HScode格式不正确'
        }],
        hxItemCode: [{
          required: true,
          message: '请输入映射核心标的代码',
          trigger: 'change'
        }, {
          pattern: /^[A-Z0-9a-z]+$/,
          message: '映射核心标的代码格式不正确'
        }] // userCode: [
        //   { required: true, message: '请输入统一社会信用代码证', trigger: 'blur' },
        //   { pattern: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g, message: '18位信用代码格式不正确' }
        // ],

      }
    }, "screenLoading", null);
  },
  mounted: function mounted() {
    // this.company = this.form.insuranceCompanyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode
    this.company = this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'));
    this.getData();
  },
  methods: {
    openFullScreen2: function openFullScreen2() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 有效
    isActive: function isActive(type, id) {
      var _this = this;

      this.$confirm("\u6B64\u64CD\u4F5C\u5C06\u628A\u8BE5\u6807\u7684\u7F6E\u4E3A".concat(type == '1' ? '有效' : '无效', ", \u662F\u5426\u7EE7\u7EED?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.openFullScreen2();

        updateValidStatus({
          tbcItemId: id,
          flag: type
        }).then(function (res) {
          _this.screenLoading.close();

          if (res.resultCode == '0000') {
            _this.$message({
              type: 'success',
              message: '修改成功!'
            });

            _this.getData();
          } else {
            _this.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消修改状态'
        });
      });
    },
    // // 点击新增按钮
    // newSave(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       saveItem(this.markForm).then(res => {
    //         this.new_edit = this.newumarBtn = false
    //         console.log(res)
    //         if (res.resultCode == '0000') {
    //           this.$message({
    //             message: '保存成功',
    //             type: 'success'
    //           })
    //           f
    //           this.getData()
    //         } else {
    //           this.$message({
    //             message: res.resultMsg,
    //             type: 'warning'
    //           })
    //         }
    //       })
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    //编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this2 = this;

      var data = type == 'edit' ? this.markForm : this.markForm_new;

      if (type == 'edit') {
        this.markForm.type = '1';
      } else {
        this.markForm_new.type = '0';
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (type == 'edit') {
            if (_this2.markForm.isCompanyLevel === '0') {
              if (_this2.markForm.userCode === '') {
                _this2.$message({
                  message: '客户统一信用代码不能为空',
                  type: 'warning'
                });

                return;
              }

              if (_this2.markForm.userName === '') {
                _this2.$message({
                  message: '客户名称不能为空',
                  type: 'warning'
                });

                return;
              }
            } else {
              _this2.markForm.userCode = '';
              _this2.markForm.userName = '';
            }
          } else {
            if (_this2.markForm_new.isCompanyLevel === '0') {
              if (_this2.markForm_new.userCode === '') {
                _this2.$message({
                  message: '客户统一信用代码不能为空',
                  type: 'warning'
                });

                return;
              }

              if (_this2.markForm_new.userName === '') {
                _this2.$message({
                  message: '客户名称不能为空',
                  type: 'warning'
                });

                return;
              }
            } else {
              _this2.markForm_new.userCode = '';
              _this2.markForm_new.userName = '';
            }
          }

          _this2.openFullScreen2();

          saveItem(data).then(function (res) {
            _this2.screenLoading.close();

            _this2.new_edit = _this2.newumarBtn = false;
            console.log(res);

            if (res.resultCode == '0000') {
              _this2.$message({
                message: '保存成功',
                type: 'success'
              });

              for (var key in _this2.markForm_new) {
                _this2.markForm_new[key] = '';
              }

              _this2.getData();
            } else {
              _this2.$message({
                message: res.resultMsg,
                type: 'warning'
              });
            }

            _this2.markForm_new = {
              tbcItemId: '',
              type: '',
              itemCode: '',
              itemName: '',
              hsCode: '',
              hxItemCode: '',
              userCode: '',
              userName: '',
              isCompanyLevel: ''
            };
          });
        } else {
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      this.editData = data;
      this.new_edit = true;

      for (var key in this.markForm) {
        this.markForm[key] = data[key];
      }

      if (this.markForm.isCompanyLevel === '0') {
        this.markFormIsCompanyLevelShow = true;
      } else {
        this.markFormIsCompanyLevelShow = false;
      }
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this3 = this;

      if (type == 'new') {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.$nextTick(function () {
        _this3.$refs[formname].clearValidate();
      });
    },
    // 获取下载链接
    getExecl: function getExecl() {
      getExcelPath({
        fileDownloadType: 'item'
      }).then(function (res) {
        if (res.rtnCode == '0000') {
          // 获取下载文件
          download({
            fileSrc: res.fileSrc
          }).then(function (res2) {
            var blob = new Blob([res2], {
              type: "application/vnd.ms-excel"
            });
            var url = window.URL.createObjectURL(blob);
            var link = document.createElement("a"); // 创建a标签

            link.href = url;
            link.download = "自定义标的清单模板.xlsx"; // 重命名文件

            link.click();
            URL.revokeObjectURL(url); // 释放内存
          });
        }
      });
    },
    // 上传
    importExcel: function importExcel(file) {
      var _this4 = this;

      var extension = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);

      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
        return;
      }

      var dataFile = new FormData();
      dataFile.append('file', file.file);
      this.openFullScreen2();
      item_import(dataFile).then(function (res) {
        _this4.screenLoading.close();

        if (res.resultCode == '0000') {
          _this4.$message({
            type: 'success',
            message: '导入成功'
          });

          _this4.getData();
        } else {
          _this4.$message({
            type: 'warning',
            message: res.resultMsg
          });
        }
      });
    },
    //   查询
    submitForm: function submitForm(formName) {
      this.form.pageNo = 1;
      this.getData();
    },
    // 获取数据
    getData: function getData() {
      var _this5 = this;

      this.loading = true;
      mark_query(_objectSpread({}, this.form)).then(function (res) {
        _this5.loading = false;
        _this5.total = res.totalCount;
        _this5.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.form.itemCode = this.form.itemName = this.form.userName = this.form.isCompanyLevel = '';
      this.form.pageNo = 1;
      this.form.pageSize = 10; // this.getData()
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    // 删除
    dele: function dele(data) {
      var _this6 = this;

      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteItem({
          tbcItemId: data.tbcItemId
        }).then(function (res) {
          console.log(res);

          if (res.resultCode == '0000') {
            _this6.$message({
              type: 'success',
              message: '删除成功!'
            });

            _this6.getData();
          } else {
            _this6.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //切换显示客户名称
    isCompanyLevelShow: function isCompanyLevelShow() {
      if (this.markForm.isCompanyLevel === '0') {
        this.markFormIsCompanyLevelShow = true;
      } else {
        this.markFormIsCompanyLevelShow = false;
      }
    },
    newIsCompanyLevelShow: function newIsCompanyLevelShow($event) {
      if (this.markForm_new.isCompanyLevel === '0') {
        this.markFormNewIsCompanyLevelShow = true;
      } else {
        this.markFormNewIsCompanyLevelShow = false;
      }
    }
  }
};